import { useTranslation } from "react-i18next";
import InformationFrame from "../../../common/components/InfomationFrame/InformationFrame";
import ModalConfirmation from "../../../common/components/Modal/ModalConfirmation";
import { useAppDispatch } from "../../../common/state/hooks";
import {
  closeConfirmationModal,
  openConfirmationModal,
} from "../../../common/state/slice/modal/modalSlice";
import { useTourView } from "../engine/useTourView";
import { TOUR_VIEW_ANCHORS } from "../engine/tourViewAnchors";
import { useDemoDataCleanup } from "../hooks/useDemoDataCleanup";

const DEMO_CLEANUP_MODAL_ID = "onboarding-demo-data-cleanup";

interface IDemoDataBannerProps {
  visible: boolean;
  sessionsMode?: "summary";
  onCleaned?: () => void;
}

const DemoDataBannerContent = ({
  sessionsMode,
  onCleaned,
}: Omit<IDemoDataBannerProps, "visible">) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { runCleanup } = useDemoDataCleanup({ sessionsMode, onCleaned });
  useTourView("demo-data-banner", true, TOUR_VIEW_ANCHORS["demo-data-banner"]);

  const handleCleanup = (): void => {
    dispatch(closeConfirmationModal(DEMO_CLEANUP_MODAL_ID));
    runCleanup();
  };

  return (
    <>
      <InformationFrame
        style="warning"
        showCloseButton={false}
        withTimeout={false}
        className="mx-4"
        innerClassName="flex items-center p-3 my-2 rounded-lg relative"
      >
        <div
          className="flex w-full flex-col sm:flex-row sm:items-center gap-2 pointer-events-auto"
          data-tour="demo-data-banner"
        >
          <div className="flex-1">
            <p className="font-medium">{t("onboarding.demoData.bannerTitle")}</p>
            <p className="text-sm">{t("onboarding.demoData.bannerBody")}</p>
          </div>
          <button
            type="button"
            className="btn-alternative-outline shrink-0"
            onClick={() => dispatch(openConfirmationModal(DEMO_CLEANUP_MODAL_ID))}
          >
            {t("onboarding.demoData.deleteButton")}
          </button>
        </div>
      </InformationFrame>
      <ModalConfirmation
        id={DEMO_CLEANUP_MODAL_ID}
        title={t("onboarding.demoData.confirmTitle")}
        text={t("onboarding.demoData.confirmText")}
        danger
        onClickSubmit={handleCleanup}
      />
    </>
  );
};

export const DemoDataBanner = ({ visible, sessionsMode, onCleaned }: IDemoDataBannerProps) =>
  visible ? <DemoDataBannerContent sessionsMode={sessionsMode} onCleaned={onCleaned} /> : null;

export default DemoDataBanner;
